<template>
  <div class="po" style="height: 100%;">
    <el-table :data="noticeList" v-loading="loading" style="width: 100%;" height="calc(100% - 50px)">
      <el-table-column type="index" label="序号" width="100">
      </el-table-column>
      <el-table-column prop="CreateTime" label="日期" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.CreateTime | datefmt("YYYY-MM-DD")}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="CreateTime" label="时间" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.CreateTime | datefmt("HH:mm:ss")}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="AuditState" label="审核状态" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.AuditState === 1">申请中</span>
          <span v-if="scope.row.AuditState === 2">已申请</span>
          <span v-if="scope.row.AuditState === 3">已审核</span>
          <span v-if="scope.row.AuditState === 4">申请被拒绝</span>
        </template>
      </el-table-column>
      <el-table-column prop="NoticeLevel" label="级别" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.NoticeLevel == 0 ? '一般' : '重要'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Title" label="标题" width="300">
        <template slot-scope="scope">
          <i v-show="scope.row.State == 0 ? true : false" class="editorstyle"></i><span>{{scope.row.Title}}</span>
        </template>           
      </el-table-column>
      <el-table-column prop="Content" label="内容" width="500" >
        
      </el-table-column>
      <el-table-column prop="Remark" label="备注" >
        
      </el-table-column>
      <el-table-column label="操作">
          <template slot-scope="scope">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <el-button class="el-icon-caret-bottom el-icon--right opera_btn" type="primary" size="mini"></el-button>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="clearfix" v-show="scope.row.State == 0 ? false : true" @click.native="lookinfo(scope.row)">
                  查看
                  <el-badge class="mark">
                  </el-badge>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix" v-show="scope.row.State == 0 ? true : false" @click.native="handleClick(scope.row,-1)">
                  编辑
                  <el-badge class="mark">
                  </el-badge>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix" v-show="scope.row.State == 0 ? true : false" @click.native="deletenotice(scope.row)">
                  删除
                  <el-badge class="mark">
                  </el-badge>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" size="small" class="buton" icon="el-icon-plus"  @click="addnoticebtn(0)" style="margin-top:60px;position: fixed; right: 20px">新增</el-button>
    <el-dialog :title="dialogtitle" :close-on-click-modal="false" class="alert_title alert_notice" :visible.sync="dialogFormVisible" @close="resetForm('notice')" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-form :model="notice" :label-position="labelPosition" :rules="rules" ref="notice">
        <el-form-item label="指定对象：">
          <el-select v-model="assignvalue" placeholder="请选择"  @change="FilterChangeType" style="width: 25%;">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>            
          </el-select>         
             <el-select v-model="userType" @change="FilterChangeUserType" multiple filterable :filter-method="remoteMethod" ref="chooseFilter" value-key="Name" :placeholder="placeholdervalue" style="width: 70%;float: right;">
                <el-option v-for="(item,index) in displaylists" :key="index" :label="item.Name" :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="通知级别:" prop="NoticeLevel">
          <el-select v-model="notice.NoticeLevel" placeholder="请选择" style="width:98%">
                    <el-option
                      v-for="item in NoticeLevelList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
        </el-form-item>
        <el-form-item label="通知标题:" prop="title">
          <el-input v-model="notice.title" placeholder="请输入标题" clearable></el-input>
        </el-form-item>

        <el-form-item label="通知内容:" prop="content">
          <el-input v-model="notice.content" auto-complete="off" type="textarea" class="input_textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('notice')" size="small">取 消</el-button>
        <el-button type="primary" @click="sendNotice('notice')" size="small">发送通知</el-button>
        <el-button type="primary" @click="addDataToDraft('notice')" size="small">保存草稿</el-button>
      </div>
    </el-dialog>
    <el-dialog title="通知详情" :visible.sync="dialogVisible1" append-to-body width="38%" top="13vh" center>
            <p style="border-bottom:1px solid #ccc;padding-bottom: 10px;"><span style="font-size: 16px;font-weight: 700;">标题:</span><span style="margin-left:30px;font-size: 16px;">{{obj.Title}}</span></p>
            <p style="font-size: 16px;font-weight: 700;margin-top:20px;">内容：</p>
            <p style="border:1px solid #ccc;padding: 20px;min-height: 300px;margin-bottom: 25px;">{{obj.Content}}</p>
            <p style="border-bottom:1px solid #ccc;padding-bottom: 10px;"><span style="font-size: 16px;font-weight: 700;">备注:</span><span style="margin-left:30px;font-size: 16px;">{{obj.Remark}}</span></p>
    </el-dialog>
    <div class="pagination_m text-center">
      <pagination :pagerPro="Pager" @ee="pageFn"></pagination>
    </div>
  </div>
</template>

<script>
import pagination from "../../paging.vue";
export default {
  //系统通知
  name: "noticeAgents",
  components: {
    pagination
  },
  data() {
    var rulesTitle = (rule, value, callback) => {
      value.split("").forEach(item => {
        if (item == " ") {
          return callback(new Error("标题中不能含有空格字符"));
        }
      });
    };
    var rulesContent = (rule, value, callback) => {
      let val = value.split("");
      val.forEach(item => {
        if (val[0] == " ") {
          return callback(new Error("不能以空格开头"));
        }
      });
    };
    return {
      dialogVisible1: false,
       obj: {},
      loading: "",
      Pager: {
        PageNo: 1,
        PageSize: 20,
        RecordCount: 0
      },
      labelPosition: "top",
      noticeList: [],
      dialogFormVisible: false,
      notice: {
        title: "",
        content: "",
        NoticeLevel: 0,
        keyWords: []
      },
      NoticeLevelList: [
        {
          label: '一般',
          value: 0
        },
        {
          label: '重要',
          value: 1
        }
      ],
      options:[
        {
          value: '3',
          label: '代理'
        }, {
          value: '4',
          label: '用户'
        }
      ],
      assignvalue:"",
      rules: {
        title: [
          { required: true, message: "请输入通知标题", trigger: "blur" },
        ],
        NoticeLevel: [
          { required: true, message: "请选择通知级别", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入通知内容", trigger: "blur" },
        ]
      },
      options4: [],
      lists: [],
      displaylists:[],
      filterlists:[],
      loading: false,
      dialogtitle:"",
      setstate:null,
      Id: 0,
      userType:[],
      placeholdervalue:"",
      CodeList:[],
    };
  },
  created() {
    this.$store.state.loaction = "/selects/noticeAgents";
  },
  mounted() {
    this.getNotices();
  },
  methods: {
    resetForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
      this.dialogtitle = "";
      this.notice.title = "";
      this.notice.content = "";
      this.assignvalue = "";
      this.userType = [];
    },
    getNotices() {
      this.loading = true;
      var url = "/Notice/GetAgentSendNoticeList";
      this.$loginapi.postWithPage(
        url,
        this.Pager.PageNo,
        this.Pager.PageSize,
        "",
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            this.noticeList = response.Data;
            if (this.Pager.PageNo == 1) {
              this.Pager = response.Pager;
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    FilterChangeType(){
        if(this.assignvalue == 3){
             this.placeholdervalue = "请选择代理";
             this.getAgentList();
        }
        if(this.assignvalue == 4){
             this.placeholdervalue = "请选择用户";
             this.getUserList();
        }
    },
    remoteMethod(query) {
      if (query !== "") {
        setTimeout(() => {
          this.displaylists = this.filterlists.filter(item => {
            return item.Code.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.displaylists = jQuery.extend([], this.lists);
      }
    },
    FilterChangeUserType(val) {
      val.forEach(item => {
        if (item.Code == "") {
          this.userType = [item];
        }
      });
    },
    // 点击新增
    addnoticebtn(n){
        this.CodeList = []; 
        this.setstate = n;
        this.Id = 0;
        this.dialogtitle = "新增通知";
        this.dialogFormVisible = true;
        this.notice.NoticeLevel = 0;
    },
    // 发送通知
    sendNotice(formName) {
      if(this.assignvalue == "" || this.userType.length == 0){
         this.$message.error("请选择指定对象");
         return;
      }
      console.log(this.userType);
      if(this.userType[0].Code == "" || this.userType[0].Name == "所有代理"){
        this.displaylists.forEach(item => {
          if (item.Code == "") {
            this.CodeList = [];
          } else {
            this.CodeList.push(item.Code);
          }
        });          
      }else{
        this.userType.forEach(item => {
          if (item.Code == "") {
            this.CodeList = [];
          } else {
            this.CodeList.push(item.Code);
          }
        });          
      }
      console.log(this.CodeList)
      this.$refs[formName].validate((valid) => {
         if (valid) {
            this.loading = true;
            this.$loginapi.post(
              "/Notice/AgentSaveAndSendNotice",
              {
                Title: this.notice.title,
                Content: this.notice.content,
                SendType: 3,
                NoticeLevel: this.notice.NoticeLevel,
                ReceiveType: this.assignvalue,
                UserCodes: this.CodeList,
                Id: this.Id
              },
              response => {
                this.loading = false;
                if (response.Ret == 0) {
                  this.Id = 0;
                  this.dialogFormVisible = false;
                  this.$message.success(response.Msg);
                  this.getNotices();
                } else {
                  this.$message.error(response.Msg);
                }
              }
            );             
         }else{
             this.$message.error("请按照提示完成发布通知信息");
         }
      })
    },
        //获取代理
    getAgentList() {
      this.$loginapi.post("/common/GetAgentCodeList", "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.lists = [{ Code: "", Name: "所有代理" }];
          }
          response.Data.forEach(item => {
            this.lists.push({
              Code: item.Code,
              Name: item.Code + "(" + item.Name + ")"
            });
          });
          this.displaylists = jQuery.extend([], this.lists);
          this.filterlists = jQuery.extend([], this.lists);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
        //      获取子账户
    getUserList() {
      this.lists = [];
      this.userTypeB = [];
      var url = "common/GetInsUserCodeList";
      let postData = {
          type:1,
          AgentCode:"",
      }
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.lists = [{ Code: "", Name: "所有子账户" }];
          }
          response.Data.forEach(item => {
            this.lists.push({
              Code: item.Code,
              Name: item.Code + "(" + item.Name + ")"
            });
          });
          this.displaylists = jQuery.extend([], this.lists);
          this.filterlists = jQuery.extend([], this.lists);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    //根据关键字查找子账户
    getUserID(query) {
      this.$loginapi.postWithPage(
        "/report/QueryAllUsersForNotice",
        1,
        30,
        {
          AgentCode: JSON.parse(sessionStorage.getItem("userInfo")).UserCode,
          QueryString: query
        },
        response => {
          if (response.Ret == 0) {
            this.Lists = response.Data.map(item => {
              return { value: item.UserCode, label: item.UserName };
            });
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    // 保存至草稿
    addDataToDraft(formName) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
                let url = "/Notice/AddNoticeDraft";
                if (this.setstate == -1) {
                  url = "/Notice/UpdateNoticeDraft";

                }
                let postData = {
                    Title: this.notice.title,
                    Content: this.notice.content,
                    NoticeLevel: this.notice.NoticeLevel,
                    Id: this.Id
                };
                this.$loginapi.post(url, postData, response => {
                    if (response.Ret == 0) {
                    this.title = "";
                    this.content = "";
                    this.Id = 0;
                    this.getNotices();
                    this.resetForm('notice');
                    this.$message.success({
                        message: "保存成功",
                        center: true,
                        duration: 800
                    });
                    } else {
                    this.$message.error(response.Msg);
                    }
                });
            }else{
                this.$message.error("请按照提示完成发布通知信息");
            }
        })

    },
    // 删除通知
    deletenotice(row){
        this.$confirm('此操作将删除草稿, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let postData = {
               Id: row.ID
            }
            this.$loginapi.post("/Notice/DeleteNoticeDraft", postData, response => {
                if (response.Ret == 0) {                
                  this.$message.success("删除成功");
                  this.Id = 0;
                  this.getNotices();
                } else {
                  this.$message.error(response.Msg);
                }
            });          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除草稿'
          });          
        });
    },
    // 查看
    lookinfo(row){
        this.dialogVisible1 = true;
        this.obj = row;
    },
    handleClick(row,n) {
        console.log(row);
      this.CodeList = [];
      this.setstate = n;
      this.Id = row.ID;
      this.dialogtitle = "编辑通知内容"
      this.dialogFormVisible = true;
      this.notice.title = row.Title;
      this.notice.content = row.Content;
      this.notice.NoticeLevel = row.NoticeLevel;
    },
    pageFn(size, PageNo) {
      this.Pager.PageSize = size;
      this.Pager.PageNo = PageNo;
      this.getNotices();
    },
    addItem(value) {
      this.notice.keyWords = value;
    },
  }
};
</script>

<style scoped>
.editorstyle{
    background-image: url('../../../assets/images/setvalue.png');
    position: absolute;
    width: 16px;
    height: 17px;
    left: -30px;
    top: 16px
}
</style>



// WEBPACK FOOTER //
// src/components/selects/SendNoticeList/SendNoticeListT.vue